import { createContext } from 'react';
import { StickyMessageInterface } from 'types/types';

export interface HeaderContextType {
  stickyMessages: StickyMessageInterface[];
  setStickyMessages: (messages: StickyMessageInterface[]) => void;
}

export const HeaderContext = createContext<HeaderContextType | null>(null);
